import React, { createContext, useCallback, useContext } from 'react'
import { usePersistedState } from '../api/localStore'

const STORAGE_KEY = 'advanced.dashboard.editMode'

type EditModeState = [boolean, () => void]

const useStandaloneEditMode = (): EditModeState => {
  const [editMode, setEditMode] = usePersistedState(STORAGE_KEY, false)
  const toggle = useCallback(() => setEditMode((current) => !current), [setEditMode])

  return [editMode, toggle]
}

const EditModeContext = createContext<EditModeState | null>(null)

export const EditModeProvider = ({ children }: { children: React.ReactNode }) => {
  const state = useStandaloneEditMode()

  return <EditModeContext.Provider value={state}>{children}</EditModeContext.Provider>
}

// Falls back to its own instance where no `EditModeProvider` wraps the caller — the integrated
// surface has nowhere to mount a toggle yet.
export const useEditMode = (): EditModeState => {
  const fromContext = useContext(EditModeContext)
  // Always called, even when unused — a hook cannot be called conditionally.
  const standalone = useStandaloneEditMode()

  return fromContext ?? standalone
}
